import { render, staticRenderFns } from "./ReportMobile.vue?vue&type=template&id=233e22e7&scoped=true&"
import script from "./ReportMobile.vue?vue&type=script&lang=ts&"
export * from "./ReportMobile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233e22e7",
  null
  
)

export default component.exports